import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';

import React from 'react';

import { Text } from '@thinkific/chalk/Text';

import styles from './ProfilePostEmptyState.module.scss';

const cx = classNames.bind(styles);

interface ProfilePostEmptyStateProps {
  userName: string;
}

const ProfilePostEmptyState: React.FC<ProfilePostEmptyStateProps> = ({ userName }) => {
  const { t } = useTranslation();

  return (
    <div className={cx('profile-empty-state')}>
      <Text as="h2" data-qa={cx('profile-empty-state__title')} variant="display.sm">
        {t('No activity to show')}
      </Text>
      <Text as="p" data-qa="profile-empty-state__subtitle" variant="body.md">
        {t(
          'components-profile-profile_empty_state_no_recent_posts',
          '{{userName}} hasn’t posted in the last while.',
          {
            userName,
          }
        )}{' '}
        {t(
          'components-profile-profile_empty_state_suggestion',
          'Invite them to a conversation by mentioning their name.'
        )}
      </Text>
    </div>
  );
};

export default ProfilePostEmptyState;
